module.exports = __webpack_public_path__ + "media/images/redesign-images/cm/alexis-poster-43b3e986af0630dcec604347bff2c4d3.jpg";